import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getSensorOrders = async (projectId) => {
  const apiPath = `projects/${projectId}/renolog/sensor-orders`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);
  return response.data;
};
